module.exports = __webpack_public_path__ + "img/see-no-evil-monkey.25104c18.png";